import React from 'react';
import c from 'classnames';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import './style.scss';

const Video = ({ url, className }) => {
  const classNames = c('Video', className);

  return (
    <div className={classNames}>
      <ReactPlayer
        className="Video__inner"
        url={url}
        width="100%"
        controls
      />
    </div>
  );
};

Video.defaultProps = {
  className: '',
};

Video.propTypes = {
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Video;
